import { instance } from "../../utils/Axios";

export const loginUserApi = (data) => {
  return instance.post("/login", data).then((response) => {
    return response;
  });
};